import React from 'react';
import PropTypes from 'prop-types';
import { mapStackTrace } from 'sourcemapped-stacktrace';
import { ErrorMessage } from './ErrorMessage';

export class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { error: null };
  }

  componentDidCatch(rawError) {
    const { name, onError } = this.props;

    mapStackTrace(rawError.stack, (mappedStack) => {
      const error = {
        message: name ? `${name} - ${rawError.message}` : rawError.message,
        stack: mappedStack ? mappedStack[0] : null,
      };

      this.setState({ error });

      if (typeof onError === 'function') {
        onError(error);
      }
    });
  }

  render() {
    const { children, ...props } = this.props;
    const { error } = this.state;

    if (error) {
      return <ErrorMessage {...props} error={error} />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  onError: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  children: null,
  name: null,
  onError: null,
};
